import React from 'react';
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import mission from '../images/mission.png';

const tabItems = [
  {
    id: 0,
    title: 'Our Vision',
    text: 'To become the most trusted renewable energy producer by combining global resources with local talent.',
  },
  {
    id: 1,
    title: 'Our Mission',
    text: 'To develop rooftop solar projects that yields green energy every year as promised.',
  },
  {
    id: 2,
    title: 'Execution',
    text: 'Install 100 MWp in 3 years and 500 MWp in 5 years.',
  },
];

export const TabSection = () => {
  return (
    <div className='bg-white featured-service my-5'>
      <div className='container py-5'>
        <div className='row'>
          <div className='col-md-6 pl-3 d-flex flex-column justify-content-center'>
            <h4 className='title'>COMMITMENT</h4>
            <Zoom left>
              <h2 className='subtitle' style={{ fontSize: '1.5rem' }}>
                We’re Solaric
              </h2>
            </Zoom>
            <div className='tabs my-3'>
              <Tabs>
                <TabList>
                  {tabItems.map((tab, i) => (
                    <Tab key={i}>{tab.title}</Tab>
                  ))}
                </TabList>
                {tabItems.map((tab, i) => (
                  <TabPanel key={i}>
                    <Fade bottom>
                      <p>{tab.text}</p>
                    </Fade>
                  </TabPanel>
                ))}
              </Tabs>
            </div>
          </div>
          <div className='col-md-6'>
            <img className='p-5' src={mission} alt='' />
          </div>
        </div>
      </div>
      <div id='innovations'></div>
    </div>
  );
};
